import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, defaultTo, times } from 'ramda';
import { withFormik } from 'formik';
import Select from 'react-select';

import { apiAdminCreateMembership } from '../../api/membership';
import { handleError, handleSuccess } from '../../util/forms';

import Modal from '../Modal';
import EditField from '../Forms/EditField';

const mapState = ({ memberships }) => ({ memberships });

class CreateMembershipModal extends Component {
  static propTypes = {
    user: PropTypes.object,
    onHide: PropTypes.func,
    updateuser: PropTypes.func,
    memberships: PropTypes.array,
  };

  state = {
    show: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && !prevState.show && nextProps.show && nextProps.resetForm) {
      nextProps.resetForm();
    }

    return { show: defaultTo(false, nextProps.show) };
  }

  render() {
    const {
      onHide,
      values,
      handleBlur,
      handleSubmit,
      setFieldValue,
      isSubmitting,
      isValid,
      status,
      memberships,
    } = this.props;
    const { show } = this.state;

    return (
      <Modal show={show} onHide={onHide} title="Add Membership">
        <form>
          <Modal.Body className="px-5">
            <EditField
              full
              as={Select}
              bare
              simpleValue
              label="Membership"
              name="membershipId"
              status={status}
              onChange={(value) => setFieldValue('membershipId', value)}
              onBlur={handleBlur}
              value={values.membershipId}
              options={memberships.map((membership) => ({
                value: membership.categoryId,
                label: membership.name,
              }))}
            />
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={onHide}>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isValid || isSubmitting}
              onClick={handleSubmit}
            >
              Save changes
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default compose(
  connect(mapState),
  withFormik({
    handleSubmit: (payload, formProps) => {
      const { props } = formProps;

      apiAdminCreateMembership(props.user.id, payload.membershipId)
        .then(({ data }) => props.updateUser(data))
        .then(() => handleSuccess(formProps))
        .then(props.onHide)
        .catch((err) => handleError(formProps, err));
    },
    mapPropsToValues: () => {
      return {
        membershipId: '',
      };
    },
    isInitialValid: true,
    validateOnChange: true,
  }),
)(CreateMembershipModal);
